export default "__VITE_ASSET__CDpzCj9S__"